import React, { useEffect, useState } from "react";
import styles from "./WorkOrderDetail.module.css";
import { MdMessage } from "react-icons/md";
import { List } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ChatMiddleware from "../../../store/Middlewares/ChatMiddleware";
import WorkOrderRequestMiddleware from "../../../store/Middlewares/WorkOrderRequestMiddleware";
import AlertAction from "../../../store/Actions/AlertActions";
import moment from "moment";
import { roles } from "../../../config/roles";

function WorkOrderDetail() {
  const navigate = useNavigate();
  const { state } = useLocation();
console.log('stateeee', state);

  useEffect(() => {
    chatlistCheck()
    getLanguage();
  }, []);


  const dispatch = useDispatch();
  const [details, setdetails] = useState([]);
  const { t, i18n } = useTranslation();
  const [InventoryList, setInventoryList] = useState();
  const user = useSelector(state => state.AuthReducer.user);
  const data = state?.data;
  const customerNumber = state?.customer_no;
  const [ChatData, setChatData] = useState(null)

  console.log('===========', data?.service_name)



  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const chatlistCheck = () => {
    dispatch(ChatMiddleware.chatlistCheck(user?.role == 'customer' ? user?.created_by : data?.customer_id))
      .then((data) => {
        setChatData(data?.data)
      })
      .catch((err) => console.log(err))
  }



  const declineRequest = () => {
    dispatch(WorkOrderRequestMiddleware.declineWorkRequest(data?.id))
      .then((data) => {
        dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
        navigate(-1)
      })
      .catch((error) => console.log(error))
  }

  //     const onPressCall = (phone) => {
  //       let phoneNumber = phone;
  //       if (Platform.OS !== 'android') {
  //         phoneNumber = `telprompt:${phone}`;
  //       }
  //       else  {
  //         phoneNumber = `tel:${phone}`;
  //       }
  //       Linking.canOpenURL(phoneNumber)
  //       .then(supported => {
  //         if (!supported) {
  //           Alert.alert('Phone number is not available');
  //         } else {
  //           return Linking.openURL(phoneNumber);
  //         }
  //       })
  //       .catch(err => console.log(err));
  // }
  const Inventories = [
    {
      id: 1,
      name: "Paper Towel",
      quantity: 3,
    },
    {
      id: 1,
      name: "Mop",
      quantity: 0,
    },
    {
      id: 1,
      name: "Wiper",
      quantity: 2,
    },
    {
      id: 1,
      name: "Bucket",
      quantity: 4,
    },
    {
      id: 1,
      name: "Brush",
      quantity: 1,
    },
  ];

  const services = [
    {
      id: 1,
      name: "Moop Floor",
    },
    {
      id: 2,
      name: "Vaccum",
    },
    {
      id: 3,
      name: "Carpet Cleaning",
    },
  ];

  const renderInventoryItem = (item) => {
    return (
      <div className={styles.flex}>
        <text className={styles.inventory_text}>{item?.name}</text>
        <text className={styles.inventory_text}>{item?.quantity}</text>
      </div>
    );
  };

  console.log('data', data);

  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.main_heading}>{t("Work Order Request")}</h1>

      <div className={styles.location_item}>
        <div className={styles.upper_view}>
          <div className={styles.heading_view}>
            <h2 className={styles.heading}>Work Order {data?.request_no}</h2>
            <text className={styles.span}>{data?.date
              ? moment(data?.date).format('MM-DD-YYYY')
              : ''}</text>
          </div>

          <div className={styles.flex}>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }} >

              {user?.role == roles.contractor && data?.status == 'pending' ?
                <>
                  <button
                    className={styles.accept_button}
                    onClick={() => navigate("/WorkOrderRequest/EditJobDetails", { state: data })}
                  >
                    {t("Accept")}
                  </button>
                  <button onClick={() => declineRequest()} className={styles.decline_button}>{t("Decline")}</button>
                </>
                : null}

            </div>
            <MdMessage onClick={() => navigate("/chat/Chat", { state: ChatData })} className={styles.icon} />
          </div>
        </div>

        <h2 className={styles.sub_heading}>{t(data?.category_name)}</h2>

        <div className={styles.sub_divs}>
          <div className={styles.sub_div_one}>
            <div className={styles.flexC}>
              <text className={styles.span}>{t("Customer Name")}</text>
              <text className={styles.text}>{data?.customer_name} </text>
            </div>
            <div className={styles.flexC}>
              <text className={styles.span}>{t("Company Name")}</text>
              <text className={styles.text}>{data?.company?.name} </text>
            </div>
            <div className={styles.flexC}>
              <text className={styles.span}>{t("Date")}</text>
              <text className={styles.text}>{data?.date
                ? moment(data?.date).format('MM-DD-YYYY')
                : ''} </text>
            </div>
            <div className={styles.flexC}>
              <text className={styles.span}>{t("Time")}</text>
              <text className={styles.text}>{moment(data?.start_time).format('hh:mm A')} </text>
            </div>

            <div className={styles.flexC}>
              <text className={styles.span}>{t("Location")}</text>
              <text className={styles.text}>{data?.location.address}</text>
            </div>

            <div className={styles.flexC}>
              <text className={styles.span}>{t("Service Name")}</text>
              <text className={styles.text}>{data?.service_name ? data?.service_name : '--'}</text>
            </div>

            <div className={styles.flexC}>
              <text className={styles.span}>{t("Service Details")}</text>
              <text className={styles.text}>{data?.details ? data?.details : '--'}</text>
              {/* <List dataSource={services} renderItem={renderServiceItem} /> */}
            </div>
          </div>

          <div className={styles.sub_div_two}>
            <div className={styles.flexC}>
              <text className={styles.span}>{t("Urgency")}</text>
              <text className={styles.text}>{data?.urgency} </text>
            </div>

            <div className={styles.flexC}>
              <text className={styles.span}>{t("Inventories")}</text>
              <List dataSource={data?.inventories ? data?.inventories : []} renderItem={renderInventoryItem} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkOrderDetail;
